@use '../../styling/colors.scss' as *;

.Frame {
  padding: 12px 48px;
  margin: 0;
  box-sizing: border-box;

  &.hasBackground {
    background: $theme-color-sub-background;
  }

  &.hasBorderTop {
    border-top: 1px solid $theme-color-borders;
  }

  &.hasBorderBottom {
    border-bottom: 1px solid $theme-color-borders;
  }

  &.hasBorderLeft {
    border-left: 1px solid $theme-color-borders;
  }

  &.hasBorderRight {
    border-right: 1px solid $theme-color-borders;
  }
}
